const loadingLabel = "Loading";
const enGB = {
  loadingLabel
};
export {
  enGB as default,
  loadingLabel
};
